/**
 * Where the API lives and how to call it. On the CRM's own server: `/api` on the same origin
 * (Vite proxies it in development, so the session cookies ride along). A host that embeds the
 * screens (`@aplopes-dev/crm/next`) sets its mount point, the credentials its origins need, and
 * takes over the session (`embedded`).
 */
export interface ApiRuntime {
  baseUrl: string;
  credentials: RequestCredentials;
  /** A host signs people in: no session refresh here, a 401 goes back to the host. */
  embedded: boolean;
}

const runtime: ApiRuntime = {
  baseUrl: import.meta.env['VITE_API_URL'] || '/api',
  credentials: 'same-origin',
  embedded: false,
};

export function configureApiRuntime(next: Partial<ApiRuntime>): void {
  Object.assign(runtime, next);
}

export function apiRuntime(): Readonly<ApiRuntime> {
  return runtime;
}

/**
 * Sent on every request. The API refuses state-changing requests without it (CSRF guard): a
 * cross-site form cannot set a custom header.
 */
export const CSRF_HEADER = 'X-Requested-With';
export const CSRF_HEADER_VALUE = 'XMLHttpRequest';
